import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const PALABRA_CONFIRMACION = 'ELIMINAR';

export default function ConfirmDeleteModal({
  open,
  title = 'Eliminar registro',
  message,
  loading = false,
  onConfirm,
  onCancel,
}) {
  const [texto, setTexto] = useState('');

  useEffect(() => {
    if (open) setTexto('');
  }, [open]);

  if (!open) return null;

  const habilitado = texto.trim().toUpperCase() === PALABRA_CONFIRMACION;

  const handleConfirm = () => {
    if (habilitado && !loading) {
      onConfirm();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-xl p-8 w-full max-w-md">
        <div className="flex items-center justify-center mb-4">
          <div className="p-3 bg-red-100 rounded-full">
            <AlertTriangle size={32} className="text-red-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">{title}</h2>
        <p className="text-gray-600 text-center mb-4">
          {message}
          <br />
          <span className="text-sm text-red-500">Esta acción no se puede deshacer.</span>
        </p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2 text-center">
            Escribí <span className="font-bold text-red-600">{PALABRA_CONFIRMACION}</span> para confirmar
          </label>
          <input
            type="text"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleConfirm(); }}
            placeholder={PALABRA_CONFIRMACION}
            autoFocus
            className="w-full px-3 py-2 border-2 rounded-lg text-center font-medium tracking-wide focus:ring-2 focus:ring-red-500 focus:border-red-500"
          />
        </div>

        <div className="flex justify-center space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={!habilitado || loading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {loading ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
}
